import { MicroFrontend } from '@praxis/component-microfrontend'
import { MFEProps } from './MFEProps'
import { envConfigs } from '../apiConfig'
import LoadingPage from 'layout/LoadingPage'
import { useContext } from 'react'
import { UserContext } from 'App/UserContext'

export const NegotiatorMFE = (props: MFEProps) => {
  const { environment, module } = props

  const { isDark } = useContext(UserContext)

  return (
    <MicroFrontend
      key={module}
      src={envConfigs[environment].negotiator.mfeSrc}
      module={module}
      Loading={LoadingPage}
      darkMode={isDark}
    />
  )
}
